import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllAirportPackages = createAsyncThunk(
  'airportPackages/getAllAirportPackages',
  async ({ limit = 10, page = 1, categoryId, locationId }, thunkAPI) => {
    let newUrl = `/airport-packages?limit=${limit}&page=${page}`;

    if (categoryId) {
      newUrl += `&category_id=${categoryId}`;
    }

    if (locationId && !Array.isArray(locationId)) {
      newUrl += `&location_id=${locationId}`;
    } else if (locationId && Array.isArray(locationId)) {
      locationId.forEach((loc) => (newUrl += `&location_id=${loc}`));
    }

    try {
      const response = await axiosInstance.get(newUrl);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// CREATE OR UPDATE
export const createAirportPackages = createAsyncThunk(
  'airportPackages/createAirportPackages',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `/airport-packages`,
        { ...payload },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteAirportPackages = createAsyncThunk('airportPackages/deleteAirportPackages', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/airport-packages/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
